import { render, staticRenderFns } from "./EventFilterFrame.vue?vue&type=template&id=2889ad82&scoped=true&"
import script from "./EventFilterFrame.controller.js?vue&type=script&lang=js&"
export * from "./EventFilterFrame.controller.js?vue&type=script&lang=js&"
import style0 from "./EventFilterFrame.styles.scss?vue&type=style&index=0&id=2889ad82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889ad82",
  null
  
)

export default component.exports